import { StringHelper } from "../../../utilities/contracts/string-helper";

export class GridPipe {

  constructor(
    private readonly pipe: { transform: any },
    private readonly isFormattable = true
  ) {
    this.pipe = pipe;
    this.isFormattable = typeof isFormattable === "boolean" ? isFormattable : true;
  }


  transform(value: string, format = "") {
    // TODO: unit test this.
    const useFormatter = this.isFormattable && StringHelper.isAvailable(format);
    const transformedValue = useFormatter ? this.pipe.transform(value, format) : this.pipe.transform(value);

    return transformedValue;
  }
}
